export default "__VITE_ASSET__BOhNXN84__"